import React, { Component } from 'react';
import '../App.css';

class Countdown extends Component {

constructor() {
	super();
	this.state = { countdown:3, countdownV: 0, countdownV1: 0, countdownW: ''};
}

componentDidMount(){
	let countdownInterval0 = setInterval(()=>{this.setState(state => ({countdown:state.countdown -= 1}))}, 1000);
	let countdownInterval1 = setInterval(()=>{this.flip()}, 427);
	
	setTimeout(()=>{clearInterval(countdownInterval1);}, 3000);
	setTimeout(()=>{clearInterval(countdownInterval0);}, 3000);
	setTimeout(()=>{document.getElementById("countdown").style.display="none";}, 3000);
	setTimeout(()=>{document.getElementById("countdown1").style.display="initial";}, 3000);
	setTimeout(()=>{this.setState({countdownW: 'Click!'});}, 3000);
	setTimeout(()=>{this.flip1();}, 3000);

	setTimeout(()=>{this.props.nextStage()}, 4500);
}

flip() {
	if (this.state.countdownV == 0) {this.setState({countdownV:1})}
		else {this.setState({countdownV:0})}
}

flip1() {
	if (this.state.countdownV1 == 0) {this.setState({countdownV1:1})}
		else {this.setState({countdownV1:0})}
}


  render() {
    return (
      <div className="countdownContainer">
        <h1 id={"countdown"} className={"countdown countdownSpin"} style={{opacity: this.state.countdownV}}> {this.state.countdown}</h1>
        <h1 id={"countdown1"} className={"countdown1"} style={{opacity: this.state.countdownV1, display:'none'}}> {this.state.countdownW} </h1>
      </div>
    );
  }
}

export default Countdown;



// WEBPACK FOOTER //
// ./src/components/Countdown.js